/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "crypto": {
            "nested": {
              "BitcoinAmount": {
                "fields": {
                  "satoshi": {
                    "type": "uint64",
                    "id": 1,
                    "rule": "required"
                  },
                  "remainderPico": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.crypto?.nested?.BitcoinAmount) {
  $root.addJSON(jsonData);
}

/**
 * A quantity of Bitcoin, internally denominated in satoshi, with a pico-btc remainder
 *
 * SOURCE BitcoinAmount @ squareup/cash/crypto/amount.proto at 7:1
 */
export const BitcoinAmount = $root.lookupType('squareup.cash.crypto.BitcoinAmount');
fixType(BitcoinAmount);
Builder.createAndAttachToType(BitcoinAmount);